<script lang="ts">
	import { twJoin } from "tailwind-merge";
	import type { LandingPage } from "#gen/bundles/v1/bundle_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import ConversionCard from "#lib/components/flow/viewer/ConversionCard.svelte";
	import type { LayoutProps } from "#lib/components/flow/viewer/layout/types.js";
	import PageBackgroundLayer, { hostBackgroundStyle } from "#lib/components/page/PageBackgroundLayer.svelte";
	import { APP_ANCHOR_NAME, CONVERSION_ANCHOR_NAME } from "#lib/dag.js";

	const { key, dag, container: landingPage, accessory, mode, backgroundPaint = "inline", style, share, conversion: nestedConversion, apps, numApps = 0, footer }: LayoutProps<LandingPage> = $props();
	const hideGradient = $derived(!landingPage.primaryText?.trim() && !landingPage.secondaryText?.text?.trim() && dag?.findConversionsByAssetKey(key).length === 0);
	const hasApps = $derived(numApps > 0);
</script>

<div class="h-full w-full justify-center" {style}>
	<div style={hostBackgroundStyle(backgroundPaint)} class={twJoin("flex h-full w-full flex-col bg-white pt-4 sm:rounded-3xl", backgroundPaint === "layer" && "relative isolate")}>
		{#if backgroundPaint === "layer"}<PageBackgroundLayer />{/if}
		{@render share?.()}
		<div class={twJoin("flex h-full flex-col gap-3 px-4 pb-5", typeof share === "function" && "mt-2")}>
			<ConversionCard class="min-h-64 grow" {landingPage} {mode} {hideGradient}>
				{#snippet conversion()}
					<div class="relative">
						{@render nestedConversion?.()}
						{@render accessory?.[CONVERSION_ANCHOR_NAME]?.()}
					</div>
				{/snippet}
			</ConversionCard>
			{#if mode !== Mode.EDITING || hasApps}
				<div class={twJoin("relative", hasApps && mode !== Mode.EDITING && "mb-3")}>
					{@render apps?.()}
				</div>
			{/if}
			{#if accessory?.[APP_ANCHOR_NAME]}
				<div class="relative">
					{@render accessory?.[APP_ANCHOR_NAME]?.()}
				</div>
			{/if}
		</div>
		{@render footer?.(mode)}
	</div>
</div>
